import styled from "styled-components";

export const Container = styled.div`
  margin-top: 9px;
  padding: 0 16px;
  box-sizing: border-box;
`;

export const CreateHead = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & a {
    height: 24px;
  }

  & h1 {
    font-weight: 700;
    font-size: 1.125rem;
    text-align: center;
    letter-spacing: -0.02em;
    padding-left: 32%;
    margin: 9px 0;
  }
`;
export const ArrowBack = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const DetailLine = styled.div`
  height: 1px;
  margin-left: -16px;
  background: #f1f3f5;
`;

export const AccusedContent = styled.div`
  margin-top: 24px;
  & fieldset {
    & legend {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 24px;
    }

    & .selectItems {
      display: flex;
      margin-bottom: 24px;

      & div {
        cursor: pointer;
      }

      & .circle {
        width: 20px;
        height: 20px;
        border: 1px solid #dfe2e6;
        border-radius: 50%;
        box-sizing: border-box;
      }

      & .selected-circle {
        width: 20px;
        height: 20px;
        border: 6px solid #ff7a00;
        border-radius: 50%;
        box-sizing: border-box;
      }

      & .reasonText {
        font-size: 14px;
        line-height: 20px;
        margin-left: 8px;
      }
    }
  }
`;

export const Registration = styled.div`
  position: relative;

  & .impossible {
    padding-top: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
    background-color: #f8f9fa;

    & div {
      font-weight: 700;
      font-size: 16px;
      text-align: center;
      letter-spacing: -0.02em;
      color: #878e95;
    }
  }

  & .possible {
    padding-top: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
    background-color: #ff7a00;
    cursor: pointer;

    & div {
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      text-align: center;
      letter-spacing: -0.02em;
    }
  }
`;
